import React from 'react';

export const Writes = () => {
  return (
    <div className="relative w-full h-[60vh] md:h-[80vh] lg:h-[100vh] overflow-hidden">
      <div className="relative flex flex-col md:flex-row items-center justify-center">
        <div className="relative w-full md:w-1/2 p-2 md:p-4">
          <img
            src={`${process.env.PUBLIC_URL}/car.png`}
            alt="Car"
            className="w-full h-auto object-cover rounded-lg shadow-lg"
          />
        </div>
      </div>
    </div>
  );
};
